<template>
  <div class="modal-actions">
    <template v-if="store.currentStep === 'input'">
      <sp-button
        v-if="store.config.addAttendeeUrl"
        variant="appearance-link"
        type="button"
        class="modal-actions__manual-add-link"
        @click="$emit('manual-add')"
      >
        Add single {{ store.config.label.toLowerCase() }}
      </sp-button>

      <sp-button variant="flat" color="primary" :disabled="store.isSubmitting" @click="store.preview()">
        Preview
      </sp-button>
    </template>

    <template v-else>
      <sp-button variant="outlined" color="primary" :disabled="store.isSubmitting" @click="store.currentStep = 'input'">
        Back
      </sp-button>

      <sp-button variant="flat" color="primary" :disabled="store.confirmDisabled" @click="store.confirm()">
        Confirm
      </sp-button>
    </template>
  </div>
</template>

<script setup>
import { useRsvpInviteStore } from "#ce/apps/SpAdmin/SpRsvpInviteApp/store/rsvpInvite";

defineEmits(["manual-add"]);

const store = useRsvpInviteStore();
</script>

<style scoped lang="scss">
.modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sp-ref-scale-8);
  width: 100%;
  padding-block: var(--sp-ref-scale-16);
  padding-inline: var(--sp-ref-scale-24);
  border-top: var(--sp-sys-border-width-default) solid var(--sp-sys-color-outline);

  --sp-comp-button-disabled-background: var(--sp-sys-color-disabled, #ccc);
  --sp-comp-button-disabled-text-color: var(--sp-sys-color-on-disabled);

  &__manual-add-link {
    margin-right: auto;

    --sp-comp-button-appearance-link-text-color: var(--sp-sys-color-primary);
    --sp-comp-button-font-short: var(--sp-sys-typescale-small-font-size, 0.875rem) / 1.25 inherit;
    --sp-comp-button-appearance-link-text-decoration: none;

    &:hover {
      --sp-comp-button-appearance-link-text-decoration: underline;
    }
  }
}
</style>
